<template>
  <div class="topbar-user">
    <btn
      v-if="!isMobile && !isTablet && userCanAddReservation"
      url="/reservation/new"
      type="success with-icon"
      iconName="plus"
      iconSize="xxxs"
      iconColor="color-light"
      class="add-reservation">
      {{ $t('common.ui.addReservation') }}
    </btn>

    <btn
      v-if="!isMobile && !isTablet && userCanAddReservation"
      @click.native="showSearchDatePopup()"
      type="neutral with-icon"
      iconName="search"
      iconSize="xxxs"
      iconColor="color-light"
      class="check-reservation-date">
      {{ $t('topBar.checkTerm') }}
    </btn>

    <topbar-notifications
      v-if="this.$config.notificationsEnabled" />

    <div
      :class="{ 'profile-wrapper': true, 'is-opened': dropdownOpened }"
      @click.stop="toggleDropdown">
      <icon
        name="hamburger-menu"
        size="s"
        primaryColor="color-light" />
      <div
        v-if="unreadedNewsCount"
        class="news-notification"></div>

      <div
        v-if="dropdownOpened"
        class="profile-dropdown"
        @click.stop="hideDropdown">
        <ul class="dropdown-items">
          <li
            v-if="isMobile"
            @click.stop
            class="item mobile-search">
            <topbar-search />
          </li>

          <li
            v-if="(isMobile || isTablet) && userCanAddReservation"
            class="item mobile-button">
            <btn
              url="/reservation/new"
              type="success with-icon full-width"
              iconName="plus"
              iconSize="xxxs"
              iconColor="color-light"
              class="add-reservation">
              {{ $t('common.ui.addReservation') }}
            </btn>
          </li>

          <li
            v-if="(isMobile || isTablet) && userCanAddReservation"
            class="item mobile-button">
            <btn
              @click.native="showSearchDatePopup()"
              type="neutral with-icon full-width"
              iconName="search"
              iconSize="xxxs"
              iconColor="color-light"
              class="check-reservation-date">
              {{ $t('topBar.checkTerm') }}
            </btn>
          </li>

          <li
            v-if="isMobile"
            class="item menu-item">
            <router-link to="/">{{ $t('topBar.yourPanel') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('calendar')"
            class="item menu-item">
            <router-link to="/calendar">{{ $t('topBar.calendar') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('history')"
            class="item menu-item">
            <router-link to="/history">{{ $t('topBar.history') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('payment') && userCanSeeFullPaymentsData"
            class="item menu-item">
            <router-link to="/payments">{{ $t('topBar.payments') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('invoices') && userCanSeeFullPaymentsData"
            class="item menu-item">
            <router-link to="/invoices">{{ $t('topBar.invoices') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('sms_history')"
            class="item menu-item">
            <router-link to="/sms-history">{{ $t('topBar.smsHistory') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('history')"
            class="item menu-item">
            <router-link to="/blocked-termins">{{ $t('topBar.blockedTermins') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('attendances_list')"
            class="item menu-item">
            <router-link to="/attendance">{{ $t('topBar.attendances') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('waiting_list')"
            class="item menu-item">
            <router-link to="/waiting-list">{{ $t('topBar.waitingList') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('surveys')"
            class="item menu-item">
            <router-link to="/surveys-filled">{{ $t('topBar.surveysFilled') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('stats')"
            class="item menu-item">
            <router-link to="/statistics">{{ $t('topBar.stats') }}</router-link>
          </li>

          <li
            v-if="currentUserIsAllowedToSee('company_details')"
            class="item menu-item">
            <router-link to="/company/">
              {{ $t('topBar.companyData') }}
            </router-link>
          </li>

          <li
            v-if="userIsWorker || userIsReceptionist"
            class="item menu-item">
            <router-link to="/your-profile/">
              {{ $t('topBar.yourProfile') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('customers')"
            class="item menu-item">
            <router-link to="/customers/">
              {{ $t('topBar.clients') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('workers')"
            class="item menu-item">
            <router-link to="/workers/">
              {{ $t('topBar.workers') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('services')"
            class="item menu-item">
            <router-link to="/services/">
              {{ $t('topBar.services') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('surveys')"
            class="item menu-item">
            <router-link to="/surveys">{{ $t('topBar.surveys') }}</router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('my_page')"
            class="item menu-item">
            <router-link to="/my-page">
              {{ $t('topBar.myPage') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('billing')"
            class="item menu-item">
            <router-link to="/billing">
              {{ $t('topBar.billing') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('reservation_rules')"
            class="item menu-item">
            <router-link to="/rules/reservations/">
              {{ $t('topBar.reservationRules') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('company_rules')"
            class="item menu-item">
            <router-link to="/rules/opening-hours/">
              {{ $t('topBar.openingRules') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('price_rules')"
            class="item menu-item">
            <router-link to="/rules/prices/">
              {{ $t('topBar.priceRules') }}
            </router-link>
          </li>

          <li
            v-if="isMobile && currentUserIsAllowedToSee('discounts')"
            class="item menu-item">
            <router-link to="/discounts/">
              {{ $t('topBar.discounts') }}
            </router-link>
          </li>

          <li
            v-if="currentUserIsAllowedToSee('settings')"
            class="item menu-item">
            <router-link to="/settings/">
              {{ $t('topBar.settings') }}
            </router-link>
          </li>

          <li
            v-if="currentUserIsAllowedToSee('reservation_parameters')"
            class="item menu-item">
            <router-link to="/reservation/parameters/">
              {{ $t('topBar.reservationParams') }}
            </router-link>
          </li>

          <li
            v-if="currentUserIsAllowedToSee('integrations')"
            class="item menu-item">
            <router-link to="/integrations/">
              {{ $t('topBar.integrations') }}
            </router-link>
          </li>

          <li
            class="item">
            <router-link to="/help">
              {{ $t('topBar.help') }}
            </router-link>
          </li>
          <li
            class="item">
            <router-link to="/news">
              {{ $t('topBar.new') }}

              <div
                v-if="unreadedNewsCount"
                class="item-notification">{{ $t('topBar.checkNews') }}</div>
            </router-link>
          </li>
          <li
            class="item"
            v-if="!userIsWorker && !userIsReceptionist && !reservationsDisabled">
            <router-link to="/settings/plugin/">
              {{ $t('topBar.disableReservations') }}
            </router-link>
          </li>
          <li
            class="item"
            v-if="!userIsWorker && !userIsReceptionist && reservationsDisabled">
            <router-link to="/settings/plugin/">
              {{ $t('topBar.enableReservations') }}
            </router-link>
          </li>
          <li
            class="item"
            @click.prevent="openCookieBanner()">
            <a href="#cookie-settings">
              {{ $t('topBar.cookieSettings') }}
            </a>
          </li>
          <li class="special-item">
            <btn
              url="/login"
              type="danger full-width">
              {{ $t('topBar.logout') }}
            </btn>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Configuration from './../mixins/Configuration';
import ErrorUtils from './../helpers/ErrorUtils.js';
import Responsive from './../mixins/Responsive';
import TopBarNotifications from './TopBarNotifications';
import TopBarSearch from './TopBarSearch';
import UserTypes from './../mixins/UserTypes';
import { mapGetters } from 'vuex';

export default {
  name: 'topbar-user',
  mixins: [
    Configuration,
    Responsive,
    UserTypes
  ],
  components: {
    'topbar-notifications': TopBarNotifications,
    'topbar-search': TopBarSearch
  },
  data () {
    return {
      dropdownOpened: false
    };
  },
  computed: {
    ...mapGetters({
      unreadedNewsCount: 'global/unreadedNewsCount'
    }),
    reservationsDisabled () {
      return !!this.$store.state.config.company.block_widget;
    }
  },
  mounted () {
    this.$bus.$on('body-clicked', this.hideDropdown);
    this.$bus.$on('hide-topbar-user-dropdown', this.hideDropdown);
  },
  methods: {
    hideDropdown () {
      this.dropdownOpened = false;
    },
    stopEventPropagation (e) {
      e.stopPropagation();
    },
    toggleDropdown (e) {
      this.$bus.$emit('hide-app-notifications');
      this.dropdownOpened = !this.dropdownOpened;
    },
    toggleReservationsMode (e) {
      e.preventDefault();
      this.dropdownOpened = false;

      if (!this.reservationsDisabled) {
        this.$bus.$emit('confirm-display', {
          title: this.$t('topBar.disableReservationsTitle'),
          desc: this.$t('topBar.disableReservationsDesc'),
          okLabel: this.$t('topBar.disableReservations'),
          okClick: this.changeReservationsMode.bind(this)
        });
      } else {
        this.changeReservationsMode();
      }
    },
    changeReservationsMode () {
      this.$http.post('/panel/general/change-fullstack').then(response => {
        this.$store.commit('config/setReservationsStatus', response.data.fullstack);

        if (response.data.fullstack === 1) {
          this.$bus.$emit('notification-display', {
            type: 'success',
            message: this.$t('topBar.reservationsDisabled')
          });
        } else {
          this.$bus.$emit('notification-display', {
            type: 'success',
            message: this.$t('topBar.reservationsEnabled')
          });
        }
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/general/change-fullstack', this.$router, this.$bus, this.changeReservationsMode.bind(this));
      });
    },
    showSearchDatePopup () {
      this.$parent.$parent.searchDateFormUniqueID = new Date().getTime();

      setTimeout(() => {
        this.$bus.$emit('show-search-date-popup');
      }, 100);
    },
    openCookieBanner () {
      let cnEvent = new CustomEvent('cn-notice-display');
      document.dispatchEvent(cnEvent);
    }
  },
  beforeDestroy () {
    this.$bus.$off('body-clicked', this.hideDropdown);
    this.$bus.$off('hide-topbar-user-dropdown', this.hideDropdown);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.topbar-user {
  display: flex;
  user-select: none;

  & > .button {
    margin-left: 1.2rem;
  }
}

.profile {
  background: $color-light;
  border-radius: $border-radius-small;
  color: $color-text;
  display: block;
  height: 3.6rem;
  line-height: 4.5rem;
  position: relative;
  text-align: center;
  width: 3.6rem;

  &-wrapper {
    cursor: pointer;
    height: 3.6rem;
    margin-left: .75rem;
    position: relative;
    width: 3.6rem;

    & > svg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
    }

    .news-notification {
      background: $color-danger;
      border: 3px solid $color-primary;
      border-radius: 50%;
      position: absolute;
      height: 15px;
      right: 0px;
      top: 51%;
      transform: translateY(-50%);
      width: 15px;
    }
  }

  .notification {
    background: $color-danger;
    border: 4px solid $color-primary;
    border-radius: $border-radius-full;
    display: block;
    height: 2.2rem;
    position: absolute;
    right: -1.1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 2.2rem;
  }

  &-dropdown {
    background: $color-light;
    border-radius: $border-radius-small;
    box-shadow: 0 0 25px rgba(0, 0, 0, .25);
    position: absolute;
    right: 0;
    top: 4.8rem;
    width: 22.5rem;
    z-index: 1000;

    .avatar {
      display: block;
      margin: 1.5rem auto;
      max-height: 5rem;
      max-width: calc(100% - 4rem);
    }

    .dropdown-items {
      list-style-type: none;
      margin: 1rem 0 2rem 0;
      padding: 0 2rem;

      .item {
        border-top: 1px solid $color-border-light;
        position: relative;

        &:first-child {
          border-top: none;
        }

        a {
          display: block;
          padding: 1rem 0;

          &:active,
          &:focus,
          &:hover {
            color: $color-text-dark;
          }
        }

        .notification-small {
          background: $color-danger;
          border-radius: $border-radius-full;
          display: block;
          height: .8rem;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: .8rem;
        }

        .item-notification {
          background: $color-danger;
          border-radius: 3px;
          color: $color-light;
          font-size: 11px;
          font-weight: bold;
          padding: 2px 4px;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        &.mobile-button {
          padding: .5rem 0;
        }
      }

      .special-item {
        margin: 1rem 0 0 0;
      }
    }
  }
}

@media (max-width: 1240px) {
  .topbar-user {
    margin-left: auto;

    & > .button {
      margin-left: 0.5rem;
    }
  }

  .profile {
    &-wrapper {
      margin-left: .5rem;
    }
  }
}

@media (max-width: 1040px) {
  .profile {
    &-dropdown {
      .dropdown-items {
        .item {
          &.desktop-only {
            display: none;
          }

          &.mobile-button {
            border: none;
          }
        }
      }
    }
  }
}

@media (max-width: 640px) {
  .profile {
    &-dropdown {
      height: auto;
      left: 1rem;
      max-height: calc(100% - 10rem);
      overflow: auto;
      position: fixed;
      -webkit-overflow-scrolling: touch;
      top: 6rem;
      width: calc(100vw - 2rem);

      .dropdown-items {
        margin: 0;
        padding: 2rem;

        .item.mobile-search {
          border: none;
          margin-top: -0.5rem;
          padding: .75rem 0;
        }

        .item.mobile-button {
          border: none;
          padding: .75rem 0;
        }
      }
    }

    &-wrapper {
      height: 3.6rem;
    }
  }

  .topbar-user {
    margin-left: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TopBarUser.vue